import React from 'react'
import { Provider, useDispatch, useSelector } from 'react-redux'
import { Button, Tooltip } from '@mui/material'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit'
import BaseMapControl from './BaseMapControl'
import { setMapExpanded } from '../../../redux/slices/Map/map'

class ExpandMapControl extends BaseMapControl {
  constructor(store, theme) {
    super({ className: 'expand-map-control' })
    this.store = store
    this.theme = theme
  }

  _renderContent() {
    const ExpandButton = () => {
      const dispatch = useDispatch()
      const mapExpanded = useSelector(state => state.mapState.mapExpanded)
      const [isHovered, setIsHovered] = React.useState(false)

      const handleToggle = () => {
        dispatch(setMapExpanded(!mapExpanded))
      }

      const buttonStyles = {
        minWidth: '30px',
        width: '30px',
        height: '30px',
        padding: 0,
        margin: 0,
        color: mapExpanded
          ? this.theme.palette.primary.main
          : this.theme.palette.text.primary,
        bgcolor:
          mapExpanded || isHovered
            ? this.theme.palette.secondary.main
            : this.theme.palette.background.paper,
        border: mapExpanded
          ? `2px solid ${this.theme.palette.primary.main}`
          : 'none',
        '&:hover': {
          bgcolor: this.theme.palette.secondary.main,
          color: this.theme.palette.primary.main,
        },
      }

      return (
        <Tooltip
          title={mapExpanded ? 'Minimizar mapa' : 'Expandir mapa'}
          placement="left">
          <Button
            onClick={handleToggle}
            size="small"
            sx={buttonStyles}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            {mapExpanded ? (
              <FullscreenExitIcon fontSize="small" />
            ) : (
              <FullscreenIcon fontSize="small" />
            )}
          </Button>
        </Tooltip>
      )
    }

    this._root.render(
      <Provider store={this.store}>
        <ExpandButton />
      </Provider>
    )
  }
}

export default ExpandMapControl
